import { useTranslation } from "react-i18next";
import * as allauth from "../../utils/allauth";
import Button from "../Button";

const TV2Login = () => {
  const { t } = useTranslation();

  const handleTV2Login = (type: "login" | "register") => {
    // Store the current path to redirect back after authentication
    localStorage.setItem("auth_return_path", "/");
    // Store the auth type to local storage for registration tracking in AuthCallback.tsx
    if (type === "register") localStorage.setItem("auth_type", type);

    const callbackUrl = "/api/accounts/auth0/login/callback/";

    try {
      // Redirect to Auth0 provider for SSO login
      allauth.redirectToProvider(
        "auth0",
        callbackUrl,
        allauth.AuthProcess.LOGIN,
      );
    } catch (error) {
      console.error("Error during TV 2 login redirect:", error);
    }
  };

  return (
    <>
      <Button
        width={1}
        variant="secondary"
        onClick={() => handleTV2Login("login")}
      >
        {t("login.tv2Login", "TV 2 Login")}
      </Button>
      <Button
        width={1}
        variant="primary"
        onClick={() => handleTV2Login("register")}
      >
        {t("login.tv2Register", "Register")}
      </Button>
    </>
  );
};

export default TV2Login;
